module.exports = __webpack_public_path__ + "a9450c325620cc0140b5ce1eafd06d23.jpg";